<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">

      <div id="Titulo_div">
        <h1>Detalle De Cita</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" v-if="cita != null">
            <div class="row">
              <div class="col-12">
                <h5> Datos de la cita #{{cita.CitaDeDictamenId}}</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12"><hr /></div>
            </div>
            <div class="row">
              <div class="col-3 d-flex justify-content-start">
                <b>Estatus:</b>
                <span>{{cita.EstatusCita.Nombre}}</span>
              </div>
              <div class="col-3 d-flex justify-content-start">
                <b>Fecha:</b>
                <span>{{cita.FechaCitaString}}</span>
              </div>

              <div class="col-3 d-flex justify-content-start">
                <b>Duración:</b>
                <span>{{cita.DuracionString}}</span>
              </div>
              <div class="col-3 d-flex justify-content-start">
                <b>Sala:</b>
                <span v-if="cita.SalaLudicaId">{{cita.SalaLudica.nombre}}</span>
                <span v-else>No</span>
              </div>
            </div>
            <div class="row new-row d-flex justify-content-start">
              <div class="col-12">
                <b>Tema a Tratar:</b>
                <span>{{cita.TemaEvaluacion.Nombre}}</span>
              </div>
            </div>
            <div class="row new-row">
              <template v-if="cita.CitaDeDictamenReferenciaId != null">
                <div class="col-3 d-flex justify-content-start">
                  <b>Cita de Referencia:</b>
                  <span>#{{cita.CitaDeDictamenReferenciaId}}</span>
                </div>
                <div class="col-3 d-flex justify-content-start">
                  <b>Número de Reagendamiento:</b>
                  <span>{{cita.NumeroDeReagendamiento}}</span>
                </div>
              </template>
              <template v-if="cita.EstatusCitaId == 3">
                <div class="col-3 d-flex justify-content-start">
                  <b>Fecha de Cancelacion:</b>
                  <span>{{cita.FechaDeCancelacion}}</span>
                </div>
                <div class="col-3 d-flex justify-content-start">
                  <b>Motivo de Cancelacion:</b>
                  <span>{{cita.MotivosCancelacion}}</span>
                </div>
              </template>
            </div>
            <div class="row new-row">
              <div class="col-12">
                <h5>Datos del evaluado</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-3 d-flex justify-content-start">
                <b>Nombre Completo:</b>
                <span>{{cita.PersonaEvaluada.NombreCompleto}}</span>
              </div>
              <div class="col-3 d-flex justify-content-start">
                <b>Sexo:</b>
                <span>{{cita.PersonaEvaluada.TipoSexo.Nombre}}</span>
              </div>
              <div class="col-3 d-flex justify-content-start">
                <b>Menor de Edad:</b>
                <span v-if="cita.PersonaEvaluada.EsMenor">Si</span>
                <span v-else>No</span>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-11"></div>
              <div class="col-1" v-if="citaId != null">
                <button class="form-control" @click="$router.go(-1)" v-if="dictamenId == null"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:5px">Regresar</span></button>
                <router-link v-else :to="{ name: 'DetalleDeDictamen', params: {dictamenId: dictamenId } }">
                  <button type="button" class="form-control"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:5px">Regresar</span></button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import CalendarioDeCitas from '@/components/SIPSIC/Dictamenes/ControlDeDictamenes/CalendarioDeCitas.vue'
  export default {
    data() {
      return {
        cita: null
      }
    },
    props: {
      citaId: 0,
      dictamenId: 0
    },
    components: {

    },
    methods: {
      getCita: function () {
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetCitaDeDictamen, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.cita = response.data.CitaDeDictamen

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      }
    }, mounted: function mounted() {
      if (this.citaId != 0)
        this.getCita();
    },
    computed: {

    }
  }
</script>

<style scoped>
  b {
    padding-right: 3px;
  }

  .new-row {
    margin-top: 20px;
  }

  .fas {
    cursor: pointer;
  }
</style>





// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ConsultaDeCitas/DetalleDeCita.vue